import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { isAuthTokenValid } from './components/utils';

const DoctorReceipts = ({ doctorName, startDate, endDate, salesNumber, customerName,patientInfo }) => {
  const [receipts, setReceipts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);


  const navigate = useNavigate();


  useEffect(() => {
    const fetchData = async () => {
      const serverURL = process.env.REACT_APP_SERVER_BASE_URL;
      const accessToken = localStorage.getItem('access_token');
      if (!isAuthTokenValid()) {
        const currentScreen = window.location.pathname.replace('/','');
        console.log('Navigating to: ',currentScreen);
        navigate('/authentication?state='+ currentScreen);
        return;
      }

      try {
        const response = await axios.get(`${serverURL}/getSalesReceipts`, {
          params: {
            doctorName,
            startDate,
            endDate,
            salesNumber,
            customerName,
            patientInfo
          }
        });
        setReceipts(response.data);
        setIsLoading(false);
      } catch (error) {
        console.error('Error fetching receipts for the doctor:', error);
        setIsLoading(false);
      }
    };
    fetchData();
  }, [doctorName, startDate, endDate, salesNumber, customerName,patientInfo,navigate]);

  // Calculate the totals
  const totals = receipts.reduce((acc, receipt) => {
    acc.Consultation += parseFloat(receipt.Consultation) || 0;
    acc.LabAndMedication += parseFloat(receipt["Lab and Medication"]) || 0;
    acc.Admission += parseFloat(receipt.Admission) || 0;
    acc.Observation += parseFloat(receipt.Observation) || 0;
    acc.Surgery += parseFloat(receipt.Surgery) || 0;
    acc.Total += parseFloat(receipt.sales_total) || 0;
    return acc;
  }, {
    Consultation: 0,
    LabAndMedication: 0,
    Admission: 0,
    Observation: 0,
    Surgery: 0,
    Total: 0
  });

  return (
    <div>
      {isLoading ? <p>Loading receipts...</p> : (
        <div>
          <h3>Receipts for Dr. {doctorName}</h3>
          <p>Date range: {startDate} to {endDate}</p>
          {receipts.length > 0 ? (
            <table style={{ border: '1px solid black', width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr>
                  <th style={{ border: '1px solid black', padding: '8px' }}>Receipt/Invoice Number</th>
                  <th style={{ border: '1px solid black', padding: '8px' }}>Patient Name</th>
                  <th style={{ border: '1px solid black', padding: '8px' }}>Date</th>
                  <th style={{ border: '1px solid black', padding: '8px' }}>Consultation</th>
                  <th style={{ border: '1px solid black', padding: '8px' }}>Lab and Medication</th>
                  <th style={{ border: '1px solid black', padding: '8px' }}>Admission</th>
                  <th style={{ border: '1px solid black', padding: '8px' }}>Observation</th>
                  <th style={{ border: '1px solid black', padding: '8px' }}>Surgery</th>
                  <th style={{ border: '1px solid black', padding: '8px' }}>Total</th>
                </tr>
              </thead>
              <tbody>
                {receipts.map((receipt, index) => (
                  <tr key={index}>
                    <td style={{ border: '1px solid black', padding: '8px' }}>{receipt.sales_number}</td>
                    <td style={{ border: '1px solid black', padding: '8px' }}>{receipt.patient_name}</td>
                    <td style={{ border: '1px solid black', padding: '8px' }}>{receipt.sales_date}</td>
                    <td style={{ border: '1px solid black', padding: '8px' }}>{parseFloat(receipt.Consultation) || 0}</td>
                    <td style={{ border: '1px solid black', padding: '8px' }}>{parseFloat(receipt["Lab and Medication"]) || 0}</td>
                    <td style={{ border: '1px solid black', padding: '8px' }}>{parseFloat(receipt.Admission) || 0}</td>
                    <td style={{ border: '1px solid black', padding: '8px' }}>{parseFloat(receipt.Observation) || 0}</td>
                    <td style={{ border: '1px solid black', padding: '8px' }}>{parseFloat(receipt.Surgery) || 0}</td>
                    <td style={{ border: '1px solid black', padding: '8px' }}>{parseFloat(receipt.sales_total) || 0}</td>
                  </tr>
                ))}
                {/* Summary row */}
                <tr>
                  <td style={{ border: '1px solid black', padding: '8px', fontWeight: 'bold' }}>Total</td>
                  <td colSpan="2" style={{ border: '1px solid black', padding: '8px' }}></td>
                  <td style={{ border: '1px solid black', padding: '8px' }}>{totals.Consultation.toFixed(2)}</td>
                  <td style={{ border: '1px solid black', padding: '8px' }}>{totals.LabAndMedication.toFixed(2)}</td>
                  <td style={{ border: '1px solid black', padding: '8px' }}>{totals.Admission.toFixed(2)}</td>
                  <td style={{ border: '1px solid black', padding: '8px' }}>{totals.Observation.toFixed(2)}</td>
                  <td style={{ border: '1px solid black', padding: '8px' }}>{totals.Surgery.toFixed(2)}</td>
                  <td style={{ border: '1px solid black', padding: '8px' }}>{totals.Total.toFixed(2)}</td>
                </tr>
              </tbody>
            </table>
          ) : <p>No receipts found for this doctor within the specified date range.</p>}
        </div>
      )}
    </div>
  );
};

export default DoctorReceipts;
